'use client'

import { signInWithCustomToken } from 'firebase/auth'
import { auth, isFirebaseConfigured } from './firebase'
import api from '@/lib/api/crate-core-api-client'

export async function signInWithAppToken() {
  if (!isFirebaseConfigured || !auth) {
    throw new Error('Firebase is not configured')
  }

  // Exchange your app token for a Firebase token
  const response = await api.post<{
    customToken: string
    uid: string
  }>('/me/realtime-exchange')

  const { customToken, uid } = response.data

  // Sign in to Firebase
  await signInWithCustomToken(auth, customToken)

  console.debug('Firebase signed in successfully')

  return {
    uid,
    customToken,
  }
}
